var React = require('react');

function Reports (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.624 12.6H1.375L1.372 1.4h3.44v4.2c0 .387.308.7.688.7h4.125l-.001 6.3zM6.187 1.4v3.5h3.438L6.187 1.4zM1.372 0h5.024c.19 0 .453.112.584.246l3.779 3.848A.983.983 0 0 1 11 4.69v7.912C11 13.373 10.385 14 9.624 14H1.376A1.39 1.39 0 0 1 0 12.6V1.4C0 .627.616 0 1.372 0z","fill":"#A9B0B7","fillRule":"evenodd"}));
}

Reports.defaultProps = {"width":"11","height":"14","viewBox":"0 0 11 14"};

module.exports = Reports;

Reports.default = Reports;
